import { Modal } from 'antd'
import React from 'react'

function ViewDocModal({isModalOpen,handleCloseModal,element}) {
  return (
    <Modal
      open={isModalOpen}
      onCancel={handleCloseModal}
      footer={null}
      centered
      width={1000}
      height={800}
    >
      <img src={element?.url} alt={element?.name} width={930} height={500}/>
    </Modal>
  )
}

export default ViewDocModal